<div class="modal-content">
  <div class="modal-header">
    <h1
      class="modal-title model-title-align"
      aria-hidden="true"
      id="my-modal-title"
    >
      {{ "APPEAL_CONFIRMATION_POP_TITLE" | globalTranslate }}
    </h1>
    <button
      type="button"
      class="btn-close pull-right"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
      />
    </button>
  </div>
  <div class="modal-body model-body-margin">
    <p
      class="p_font"
      [innerHtml]="'APPEAL_CONFIRMATION_POP_DESC1' | globalTranslate | sanitize"
      (click)="onDesc1LinkClick($event)"
    ></p>
    <br />
    <p
      class="p_font"
      [innerHtml]="'APPEAL_CONFIRMATION_POP_DESC2' | globalTranslate | sanitize"
    ></p>
    <br />
    <p
      class="p_font"
      [innerHtml]="'APPEAL_CONFIRMATION_POP_DESC3' | globalTranslate | sanitize"
    ></p>
    <br />
    <p
      class="p_font"
      [innerHtml]="'APPEAL_CONFIRMATION_POP_DESC6' | globalTranslate | sanitize"
    ></p>
    <br />
    <div class="checkbox-label" style="display: flex; align-items: baseline">
      <input
        type="checkbox"
        id="nonSubmittedAuthRepFormAckSw"
        (change)="onChangeAuthAppellantAck('NARASW', $event)"
        [checked]="nonSubmittedAuthRepFormAckSw"
        name="nonSubmittedAuthRepFormAckSw"
        checkedValue="NARASW"
      />
      <label
        for="nonSubmittedAuthRepFormAckSw"
        style="padding-left: 15px"
        [innerHTML]="'APPEAL_CONFIRMATION_POP_DESC4' | globalTranslate"
      ></label>
    </div>
    <div class="checkbox-label" style="display: flex; align-items: baseline">
      <input
        type="checkbox"
        id="submittedAuthRepFormAckSw"
        (change)="onChangeAuthAppellantAck('ARASW', $event)"
        [checked]="submittedAuthRepFormAckSw"
        name="submittedAuthRepFormAckSw"
        checkedValue="ARASW"
      />
      <label
        for="submittedAuthRepFormAckSw"
        style="padding-left: 15px"
        [innerHTML]="'APPEAL_CONFIRMATION_POP_DESC5' | globalTranslate"
      ></label>
    </div>
  </div>
  <div class="modal-footer justify-content-center">
    <div class="me-2 ml-2">
      @if (showConfirm) {
      <button
        type="button"
        id="dialog"
        class="btn d-grid btn-secondary"
        (click)="onConfirm()"
        style="height: 44px"
        [disabled]="isConfirmDisabled()"
      >
        {{ "APPEAL_CONFIRMATION_POP_BUTTON" | globalTranslate }}
      </button>
      }
    </div>
  </div>
</div>